import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, withDefaults } from 'vue';

interface Props {
    currentStep?: number;
    totalSteps?: number;
    stepLabels?: string[];
    stepsAccessible?: boolean[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsSelectorProgressBar',
  props: {
    currentStep: { default: 1 },
    totalSteps: { default: 4 },
    stepLabels: { default: () => ['Step 1', 'Step 2', 'Step 3', 'Step 4'] },
    stepsAccessible: { default: () => [true, false, false] }
  },
  emits: ["step-change"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'step-change', step: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentStep: number, totalSteps: number, stepLabels: string[], stepsAccessible: boolean[] };





const { proxy } = getCurrentInstance()!;

function navigateToStep(step: number) {
    // Only allow navigating to accessible steps
    if (props.stepsAccessible[step - 1]) {
        emit('step-change', step);
    }
}

return { __sfc: true,props, emit, proxy, navigateToStep }
}

})